<div class="summary-container">
  <!-- Toolbar com Filtros -->
  <mat-toolbar class="filter-toolbar" [formGroup]="form">
    <!-- Filtro de Cliente -->
    <mat-form-field appearance="outline">
      <mat-label>Cliente</mat-label>
      <input
        type="text"
        placeholder="Filtrar por cliente"
        aria-label="Cliente"
        matInput
        formControlName="organization"
        [matAutocomplete]="auto"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayOrganization.bind(this)"
      >
        @for (org of filteredOrganizations(); track org.id) {
          <mat-option [value]="org">{{ org.name }}</mat-option>
        }
      </mat-autocomplete>
      @if (form.controls.organization.value) {
        <button
          mat-icon-button
          matSuffix
          (click)="clearOrganization()"
          aria-label="Limpar seleção de cliente"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>

    <!-- Filtro de Data -->
    <mat-form-field appearance="outline">
      <mat-label>Escolha um intervalo</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input
          matStartDate
          [formControl]="form.controls.startDate"
          placeholder="Data inicial"
        />
        <input
          matEndDate
          [formControl]="form.controls.endDate"
          placeholder="Data final"
        />
      </mat-date-range-input>
      <mat-datepicker-toggle
        matIconSuffix
        [for]="picker"
      ></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
  </mat-toolbar>

  <!-- Container do Conteúdo -->
  <div class="summary-content">
    <!-- Visão Geral -->
    @if (viewMode() === "general") {
      <ng-container>
        @switch (generalSummary.status()) {
          @case ("loading") {
            <div class="loading-container">
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
              <span>Carregando resumo geral...</span>
            </div>
          }
          @case ("reloading") {
            <div class="loading-container">
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
              <span>Carregando resumo geral...</span>
            </div>
          }
          @case ("error") {
            <div class="error-container">
              <p>
                <mat-icon>error</mat-icon><br />Erro ao carregar o resumo geral.
              </p>
              <button
                mat-flat-button
                color="primary"
                (click)="generalSummary.reload()"
              >
                Tentar novamente
              </button>
            </div>
          }
          @case ("resolved") {
            @if (generalSummary.value(); as summary) {
              <mat-card appearance="outlined">
                <mat-card-header>
                  <mat-card-title>Visão Geral da Plataforma</mat-card-title>
                  <mat-card-subtitle>
                    Dados consolidados para o intervalo de
                    {{ formattedReferenceDate() }}
                  </mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                  <table
                    #generalTable
                    mat-table
                    [dataSource]="generalDataSource()"
                    class="summary-table"
                  >
                    <!-- Indicator Column -->
                    <ng-container matColumnDef="indicator">
                      <th mat-header-cell *matHeaderCellDef>Indicador</th>
                      <td mat-cell *matCellDef="let row; table: generalTable">
                        {{ row.indicator }}
                      </td>
                    </ng-container>

                    <!-- Reference Date Column -->
                    <ng-container matColumnDef="referenceDate">
                      <th mat-header-cell *matHeaderCellDef>Data Referência</th>
                      <td mat-cell *matCellDef="let row; table: generalTable">
                        {{ formattedReferenceDate() }}
                      </td>
                    </ng-container>

                    <!-- Value Column -->
                    <ng-container matColumnDef="value">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        class="numeric-cell"
                      >
                        Valor
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let row; table: generalTable"
                        class="numeric-cell"
                      >
                        {{ formatValue(row.value, row.unit) }}
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr
                      mat-row
                      *matRowDef="let row; columns: displayedColumns"
                    ></tr>
                  </table>
                </mat-card-content>
              </mat-card>
            } @else {
              <div class="empty-state">
                <mat-icon>info</mat-icon>
                <p>Nenhum dado encontrado para o período selecionado.</p>
              </div>
            }
          }
        }
      </ng-container>
    }

    <!-- Visão por Cliente -->
    @if (viewMode() === "organization") {
      <ng-container>
        @switch (organizationSummary.status()) {
          @case ("loading") {
            <div class="loading-container">
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
              <span>Carregando resumo do cliente...</span>
            </div>
          }
          @case ("reloading") {
            <div class="loading-container">
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
              <span>Carregando resumo do cliente...</span>
            </div>
          }
          @case ("error") {
            <div class="error-container">
              <p>
                <mat-icon>error</mat-icon><br />Erro ao carregar o resumo do
                cliente.
              </p>
              <button
                mat-flat-button
                color="primary"
                (click)="organizationSummary.reload()"
              >
                Tentar novamente
              </button>
            </div>
          }
          @case ("resolved") {
            @if (organizationSummary.value(); as summary) {
              <mat-card appearance="outlined">
                <mat-card-header>
                  <mat-card-title>Resumo do Cliente</mat-card-title>
                  <mat-card-subtitle>
                    {{ summary.organizationName }} -
                    {{ formattedReferenceDate() }}
                  </mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                  <table
                    mat-table
                    #orgTable
                    [dataSource]="organizationDataSource()"
                    class="summary-table"
                  >
                    <!-- Indicator Column -->
                    <ng-container matColumnDef="indicator">
                      <th mat-header-cell *matHeaderCellDef>Indicador</th>
                      <td mat-cell *matCellDef="let row; table: orgTable">
                        {{ row.indicator }}
                      </td>
                    </ng-container>

                    <!-- Reference Date Column -->
                    <ng-container matColumnDef="referenceDate">
                      <th mat-header-cell *matHeaderCellDef>Data Referência</th>
                      <td mat-cell *matCellDef="let row; table: orgTable">
                        {{ formattedReferenceDate() }}
                      </td>
                    </ng-container>

                    <!-- Value Column -->
                    <ng-container matColumnDef="value">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        class="numeric-cell"
                      >
                        Valor
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let row; table: orgTable"
                        class="numeric-cell"
                      >
                        {{ formatValue(row.value, row.unit) }}
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr
                      mat-row
                      *matRowDef="let row; columns: displayedColumns"
                    ></tr>
                  </table>
                </mat-card-content>
              </mat-card>
            } @else {
              <div class="empty-state">
                <mat-icon>info</mat-icon>
                <p>
                  Nenhum contrato encontrado para este cliente no período
                  selecionado.
                </p>
              </div>
            }
          }
        }
      </ng-container>
    }
  </div>
</div>
